import React from 'react';

import CandidateInfo from '../../_lib/CandidateInfo';

const ResultCandidateInfo = (props) => {
  return <CandidateInfo {...props} />;
};

export default ResultCandidateInfo;
